module.exports = __webpack_public_path__ + "img/engrane_azul.ef605890.svg";